import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "resize-area" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ContentTable = _resolveComponent("ContentTable")!
  const _component_Graph = _resolveComponent("Graph")!
  const _component_ResizableGrid = _resolveComponent("ResizableGrid")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Toaster = _resolveComponent("Toaster")!
  const _component_About = _resolveComponent("About")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("main", null, [
      _createVNode(_component_ResizableGrid, null, {
        left: _withCtx(() => [
          _createVNode(_component_ContentTable)
        ]),
        right: _withCtx(() => [
          _createVNode(_component_Graph)
        ]),
        _: 1
      }),
      _createVNode(_component_Loader, {
        show: _ctx.loading.show,
        message: _ctx.loading.message
      }, null, 8, ["show", "message"]),
      _createVNode(_component_Toaster)
    ]),
    _createVNode(_component_About),
    _hoisted_1
  ], 64))
}